import { Button, CircularProgress, Stack } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";
import { theme } from "styles/theme";
import ContentTemplateV2 from "components/task/content/ContentTemplateV2";
import image19 from "static/image/payment/typec/660_19.png";
import image20 from "static/image/payment/typec/660_20.png";
import FloatingAreaPromotion from "components/common/FloatingAreaPromotion";
import image1 from "static/image/payment/typec/660_1.png";
import image2 from "static/image/payment/typec/660_2.png";
import image3 from "static/image/payment/typec/660_3.png";
import image4 from "static/image/payment/typec/660_4.png";
import image5 from "static/image/payment/typec/660_5.png";
import image6 from "static/image/payment/typec/660_6.png";
import image7 from "static/image/payment/typec/660_7.png";
import image8 from "static/image/payment/typec/660_8.gif";
import image9 from "static/image/payment/typec/660_9.png";
import image10 from "static/image/payment/typec/660_10.png";
import image11 from "static/image/payment/typec/660_11.png";
import image12 from "static/image/payment/typec/660_12.png";
import image13 from "static/image/payment/typec/660_13.png";
import image14 from "static/image/payment/typec/660_14.png";
import image15 from "static/image/payment/typec/660_15.png";
import image16 from "static/image/payment/typec/660_16.png";
import image17 from "static/image/payment/typec/660_17.png";
import image18 from "static/image/payment/typec/660_18.png";

import useMixpanelMKT from "hooks/useMixpanelMKT";
import { useNavigate } from "react-router-dom";
import BackButton from "components/common/BackButton";
import { useMutation } from "@tanstack/react-query";
import { webFunnelApi } from "api/webFunnelApi";
import payback from "static/image/payment/typec/payback.png";
import descision from "static/image/payment/typec/decision.png";
import { useRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import useAutoLoginPromotion from "hooks/useAutoLoginPromotion";
import useFetchUserPromotion from "hooks/useFetchUserPromotion";
import { PATH } from "routes/paths";

export default function ProductContentV6() {
  const floatingAreaRef = useRef<HTMLDivElement>(null);
  const fullWidth = true;

  const [user, setUser] = useRecoilState(userSimpleAtom);
  const { isChecking } = useAutoLoginPromotion();
  const { isFetching } = useFetchUserPromotion();

  const isPaybackPolicy =
    user?.refundPolicyType !== "c" && user?.refundPolicyType !== "b";

  const navigate = useNavigate();

  const trackMixpanel = useMixpanelMKT({
    eventName: "상품 상세 페이지 진입",
    version: "v6",
  });

  const { mutate: trackEvent } = useMutation(
    ({
      eventName,
      properties,
    }: {
      eventName: string;
      properties?: { [key: string]: any };
    }) => webFunnelApi.trackEvent(eventName, properties)
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    trackMixpanel();
    trackEvent({
      eventName: "상품 상세 페이지 진입",
      properties: {
        event_source: "web",
      },
    });
  });

  // 로그인 체크 후 리다이렉트
  useEffect(() => {
    if (!isChecking && !isFetching && !user?.accessToken) {
      navigate(PATH.v6Login, { replace: true });
    }
  }, [isChecking, isFetching, user, navigate]);

  const handleBack = () => {
    navigate("/v6-onboarding/curriculum/1", { replace: true });
  };

  const { homeIndicatorHeight } = useGetDeviceInfo();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - homeIndicatorHeight
  );
  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  useEffect(() => {
    setTimeout(() => {
      setFloatingAreaHeight(floatingAreaRef.current?.offsetHeight || 0);
    }, 100);
  }, [floatingAreaRef.current]);

  const body = (
    <ContentTemplateV2
      noPadding
      noBottomPaddingChildren
      isWide
      setContainerHeight={setContainerHeight}
    >
      <Stack
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: "60px",
          backgroundColor: "transparent",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "660px",
            px: "8px",
            height: "100%",
          }}
        >
          <BackButton
            onBack={handleBack}
            iconColor={theme.vars.palette.Content.Negative}
          />
        </Stack>
      </Stack>

      {containerHeight > 0 && (
        <Stack
          sx={{
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          <Stack
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
            }}
          >
            {/* images 1-18 */}
            <img src={image1} alt={"empty"} style={{ width: "100%" }} />
            <img src={image2} alt={"empty"} style={{ width: "100%" }} />
            <img src={image3} alt={"empty"} style={{ width: "100%" }} />
            <img src={image4} alt={"empty"} style={{ width: "100%" }} />
            <img src={image5} alt={"empty"} style={{ width: "100%" }} />
            <img src={image6} alt={"empty"} style={{ width: "100%" }} />
            <img src={image7} alt={"empty"} style={{ width: "100%" }} />
            <img src={image8} alt={"empty"} style={{ width: "100%" }} />
            <img src={image9} alt={"empty"} style={{ width: "100%" }} />
            <img src={image10} alt={"empty"} style={{ width: "100%" }} />
            <img src={image11} alt={"empty"} style={{ width: "100%" }} />
            <img src={image12} alt={"empty"} style={{ width: "100%" }} />
            <img src={image13} alt={"empty"} style={{ width: "100%" }} />
            <img src={image14} alt={"empty"} style={{ width: "100%" }} />
            <img src={image15} alt={"empty"} style={{ width: "100%" }} />
            <img src={image16} alt={"empty"} style={{ width: "100%" }} />
            <img src={image17} alt={"empty"} style={{ width: "100%" }} />
            <img src={image18} alt={"empty"} style={{ width: "100%" }} />
            {!isPaybackPolicy ? (
              <img src={image19} alt={"empty"} style={{ width: "100%" }} />
            ) : (
              <>
                <img src={payback} alt={"empty"} style={{ width: "100%" }} />
                <img src={descision} alt={"empty"} style={{ width: "100%" }} />
              </>
            )}
            <img src={image20} alt={"empty"} style={{ width: "100%" }} />
          </Stack>

          <FloatingAreaPromotion
            fullWidth={fullWidth}
            ref={floatingAreaRef}
            noDivider={true}
            backgroundColor={"transparent"}
            paddingBottom={"8px"}
          >
            <Stack
              spacing={1.5}
              sx={{ width: "100%" }}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Stack
                spacing={"16px"}
                sx={{
                  width: "100%",
                  mx: "auto",
                  paddingBottom: "8px",
                }}
                alignItems="center"
                justifyContent={"space-between"}
              >
                <Button
                  onClick={() => {
                    navigate("/v6-onboarding/payment/1", {
                      replace: true,
                    });
                  }}
                  size={"lg"}
                  variant={"Soft"}
                  sx={{
                    width: "100%",
                    fontWeight: 700,
                  }}
                >
                  {"지금 시작하기"}
                </Button>
              </Stack>
            </Stack>
          </FloatingAreaPromotion>
        </Stack>
      )}
    </ContentTemplateV2>
  );

  if (isChecking || isFetching) {
    return (
      <ContentTemplateV2
        noPadding
        isWide
        setContainerHeight={setContainerHeight}
      >
        <Stack
          sx={{
            width: "100%",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          <CircularProgress color="neutral" />
        </Stack>
      </ContentTemplateV2>
    );
  }

  return body;
}
